import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// One laboratory order (KIN-1390). Refetched on mount so an order opened from the
// list reflects any acknowledgement that arrived since the list was cached.
export const useLabOrder = (labOrderId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["labOrder", labOrderId],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/healthlink/lab-orders/${labOrderId}`
      );

      return response.data;
    },
    enabled: !!tenantVal && !!labOrderId,
    staleTime: 1000 * 30,
  });
};
